import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { postNotification } from "../../../../components/utilities/Notifications";
import ListResponsive from "../../../../components/other/ListResponsive";

import * as Yup from "yup";
import { Formik, FieldArray } from "formik";
import TimerPicker from "../../../../components/utilities/TimerPicker";
import moment from "moment-timezone";
import { tabIndexes } from "../../EventOrganize";
import GenericPicker from "../../../../components/utilities/GenericPicker";
import { handlePagingAll } from "../../../../components/api/APIUtilities";
import {
  BCPAngleDown,
  BCPSquarePlus,
  BCPXmark,
} from "../../../../components/icons/bcp/BCPIcons";
import { postData } from "../../../../components/utilities/UtilityFunctions";
import { useConfirm } from "material-ui-confirm";
import DateTimePickerComponent from "../../../../components/utilities/DateTimePickerComponent";
import GameRouter from "../../../pairings/GameRouter";
import { userDisplayName } from "../EventFunctions";

export function SwapTableModal(props) {
  const { pairing, open, setOpen, setRefreshPairings, setLoading, setPairing } =
    props;
  const [table, setTable] = useState(null);

  useEffect(() => {
    if (!table || pairing?.table !== table) setTable(pairing?.table);
    // eslint-disable-next-line
  }, [pairing]);

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Change Table
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="table"
              label="Table"
              value={table}
              variant="outlined"
              fullWidth
              required
              margin="normal"
              type="number"
              onBlur={(e) => {
                var newVal =
                  e.target.value.trim() !== ""
                    ? parseInt(e.target.value)
                    : e.target.value;
                setTable(newVal);
              }}
              onChange={(e) => {
                var newVal =
                  e.target.value.trim() !== ""
                    ? parseInt(e.target.value)
                    : e.target.value;
                setTable(newVal);
              }}
              error={Boolean(!table || table === "")}
              helperText={Boolean(!table || table === "") && "Required"}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={async () => {
                if (!pairing) {
                  return;
                }
                if (!table || table === "") {
                  postNotification("error", "Please enter a new table number");
                  return;
                }

                setLoading(true);
                try {
                  await postData(`/pairings/${pairing.id}`, {
                    body: {
                      pairingType: pairing?.pairingType || "Pairing",

                      set: { table: parseInt(table) },
                    },
                  });
                  postNotification("success", "Table changed");
                  setRefreshPairings(true);
                  setLoading(false);
                  setPairing(null);
                  setOpen(false);

                  return;
                } catch (err) {
                  postNotification("error", err);
                }
                setLoading(false);
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export function SwapSeatNumberModal(props) {
  const {
    pairing,
    setPairing,
    player,
    open,
    setOpen,
    setRefreshPairings,
    setLoading,
  } = props;
  const [seatNumber, setSeatNumber] = useState(null);

  useEffect(() => {
    if (!seatNumber || player?.seatName !== `Seat ${seatNumber}`)
      setSeatNumber(player?.seatName?.split(" ").pop());
    // eslint-disable-next-line
  }, [pairing]);

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Change Seat Number
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="seatNumber"
              label="Seat Number"
              value={seatNumber}
              variant="outlined"
              fullWidth
              required
              margin="normal"
              type="number"
              onBlur={(e) => {
                var newVal =
                  e.target.value.trim() !== ""
                    ? parseInt(e.target.value)
                    : e.target.value;
                setSeatNumber(newVal);
              }}
              onChange={(e) => {
                var newVal =
                  e.target.value.trim() !== ""
                    ? parseInt(e.target.value)
                    : e.target.value;
                setSeatNumber(newVal);
              }}
              error={Boolean(!seatNumber || seatNumber === "")}
              helperText={
                Boolean(!seatNumber || seatNumber === "") && "Required"
              }
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={async () => {
                if (!pairing) {
                  return;
                }
                if (!seatNumber || seatNumber === "") {
                  postNotification("error", "Please enter a new seat number");
                  return;
                }

                setLoading(true);
                try {
                  await postData(`/pairings/${pairing.id}/changeSeatName`, {
                    body: {
                      pairingType: pairing?.pairingType || "SeatedPairing",
                      playerId: player.id,
                      seatNumber: parseInt(seatNumber),
                    },
                  });
                  postNotification("success", "Seat Number changed");
                  setRefreshPairings(true);
                  setLoading(false);
                  setPairing(null);
                  setOpen(false);

                  return;
                } catch (err) {
                  postNotification("error", err);
                }
                setLoading(false);
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export function SwapSeatedTableModal(props) {
  const {
    pairing,
    player,
    open,
    setOpen,
    pairings,
    setRefreshPairings,
    setLoading,
  } = props;

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "80vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Select Table
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ListResponsive
              originalList={pairings}
              doSearch
              doPages
              initialRowsPerPage={8}
              searchProps={{
                label: "Search Tables",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (originalList?.table?.toString().includes(searchText))
                        return true;
                      return false;
                    });

                    return filteredList;
                  }
                },
              }}
              rowProps={{
                mapFunction: (row, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      onClick={async (e) => {
                        setLoading(true);
                        try {
                          if (row?.table === player?.table) {
                            throw new Error(
                              "Player is already seated at this table"
                            );
                          }

                          await postData(
                            `/pairings/${pairing.id}/changeSeatedTable`,
                            {
                              body: {
                                pairingType:
                                  pairing?.pairingType || "SeatedPairing",
                                playerId: player.id,
                                table: row.table,
                              },
                            }
                          );
                          postNotification("success", "Seated Pairing updated");
                          setRefreshPairings(true);
                          setLoading(false);
                          setOpen(false);
                          return;
                        } catch (err) {
                          postNotification("error", err);
                        }
                        setLoading(false);
                      }}
                      sx={{
                        p: 1,
                        mb: 1,
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: 1,
                        boxShadow: 1,
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      <Grid item xs={12}>
                        Table {row.table}
                      </Grid>
                    </Grid>
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export function SwapPlayersModal(props) {
  const {
    pairing,
    player,
    open,
    setOpen,
    setRefreshPairings,
    loading,
    setLoading,
    pairings,
  } = props;

  const [players, setPlayers] = useState(null);

  const confirm = useConfirm();

  useEffect(() => {
    const formatPlayers = async () => {
      setLoading(true);
      const formattedPlayers = [...props.players];

      // Format players to include pairing information
      formattedPlayers.forEach((_player) => {
        const _pairing = pairings.find(
          (p) =>
            p?.player1?.id === _player?.id || p?.player2?.id === _player?.id
        );

        if (_pairing) {
          _player.pairing = _pairing;
        } else {
          _player.pairing = null;
        }
      });

      setPlayers(formattedPlayers);
      setLoading(false);
    };

    if (open && pairings?.length && props?.players?.length) {
      formatPlayers();
    }
    // eslint-disable-next-line
  }, [open, pairings, props.players]);

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setLoading(false);
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "80vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setLoading(false);
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Select Player
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ListResponsive
              originalList={loading ? null : players}
              doSearch
              doPages
              initialRowsPerPage={8}
              searchProps={{
                label: "Search Players",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (
                        el?.user?.firstName?.toLowerCase().includes(searchText)
                      )
                        return true;

                      if (
                        el?.user?.lastName?.toLowerCase().includes(searchText)
                      )
                        return true;
                      return false;
                    });
                    return filteredList;
                  }
                },
              }}
              rowProps={{
                mapFunction: (row, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      onClick={async (e) => {
                        setLoading(true);
                        try {
                          // Uses both row and pairing objects. Where "pairing" is the pairing that was clicked on, and "row" is the player that is selected from the list

                          const pairingData = {
                            isDone: false,
                          };

                          if (pairing?.isDone || row?.pairing?.isDone) {
                            pairingData.isDone = true;

                            if (pairing?.isDone) {
                              // Use pairing object
                              const _player = !pairing?.player1
                                ? pairing?.player2
                                : !pairing?.player2
                                  ? pairing?.player1
                                  : null;

                              pairingData.player = _player;
                              pairingData.pairingId = pairing.id;
                            } else {
                              // Use row object
                              const _player = row?.pairing?.player1
                                ? row?.pairing?.player2
                                : row?.pairing?.player2
                                  ? row?.pairing?.player1
                                  : null;

                              pairingData.player = _player;
                              pairingData.pairingId = row.pairing.id;
                            }
                          }

                          if (pairingData.isDone) {
                            try {
                              await confirm({
                                title: `Are you really sure?`,
                                description: `${
                                  pairing?.isDone && row?.pairing?.isDone
                                    ? "Both of the pairings involved have"
                                    : "One of the pairings involved has"
                                } already been scored. Do you want to erase the scores and swap players anyway?`,
                                dialogProps: {
                                  sx: {
                                    zIndex: 99999,
                                  },
                                },
                              });
                            } catch {
                              setLoading(false);
                              setOpen(false);
                              return;
                            }

                            try {
                              if (pairing?.isDone && row?.pairing?.isDone) {
                                // If both pairings are done, clear scores for both pairings
                                await postData(
                                  `/pairings/${pairing.id}/clearScores`,
                                  {
                                    pairingType:
                                      pairing?.pairingType || "Pairing",
                                  }
                                );

                                await postData(
                                  `/pairings/${row.pairing.id}/clearScores`,
                                  {
                                    pairingType:
                                      row?.pairing?.pairingType || "Pairing",
                                  }
                                );
                              } else {
                                // If only one pairing is done, clear scores for that pairing
                                await postData(
                                  `/pairings/${
                                    pairingData.pairingId
                                  }/clearScores`,
                                  {
                                    pairingType:
                                      pairing?.pairingType || "Pairing",
                                  }
                                );
                              }
                            } catch (err) {
                              postNotification("error", err);
                              setLoading(false);
                              setOpen(false);
                              return;
                            }
                          }

                          await postData(
                            `/pairings/${pairing.id}/swapPlayers`,
                            {
                              pairingType: pairing?.pairingType || "Pairing",
                              isPlayerOne: pairing.player1?.id === player?.id,
                              playerId:
                                pairingData & pairingData?.isDone
                                  ? pairingData?.player?.id
                                  : row.id,
                            }
                          );
                          postNotification("success", "Players swapped");
                          setRefreshPairings(true);
                          setOpen(false);
                        } catch (err) {
                          postNotification("error", err);
                        } finally {
                          setLoading(false);
                        }
                      }}
                      sx={{
                        p: 1,
                        mb: 1,
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: 1,
                        boxShadow: 1,
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      <Grid item xs={12}>
                        {row?.user?.firstName
                          ? userDisplayName(
                              row?.user?.firstName,
                              row?.user?.lastName
                            )
                          : row?.name}
                      </Grid>
                    </Grid>
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export function SwapTeamPlayersModal(props) {
  const {
    event,
    teamPairing,
    teamPlayer,
    open,
    setOpen,
    // teamPlayers,
    setRefreshPairings,
    setLoading,
  } = props;
  const [teamPlayers, setTeamPlayers] = useState(props.teamPlayers);

  const fetchTeamPlayers = async () => {
    var returnArray = [];
    try {
      returnArray = await handlePagingAll("/teamplayers", {
        eventId: event.id,
      });
    } catch (err) {
      postNotification("error", err);
      return undefined;
    }
    return returnArray;
  };

  useEffect(() => {
    const go = async () => {
      setLoading(true);
      let apiPlayers = await fetchTeamPlayers();
      setTeamPlayers(apiPlayers);
      setLoading(false);
    };
    if (open && !teamPlayers?.length) {
      go();
    }
    // eslint-disable-next-line
  }, [open]);

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "80vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Select Team
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ListResponsive
              originalList={teamPlayers}
              doSearch
              doPages
              initialRowsPerPage={8}
              searchProps={{
                label: "Search Teams",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (el?.name?.toLowerCase().includes(searchText))
                        return true;
                      return false;
                    });
                    return filteredList;
                  }
                },
              }}
              rowProps={{
                mapFunction: (row, index) => {
                  return (
                    <Grid
                      key={row?.id || index}
                      item
                      xs={12}
                      onClick={async (e) => {
                        setLoading(true);
                        try {
                          await postData(
                            `/pairings/${teamPairing.id}/swapPlayers`,
                            {
                              body: {
                                isPlayerOne:
                                  teamPairing.teamPlayer1?.id ===
                                  teamPlayer?.id,
                                pairingType: "TeamPairing",
                                teamPlayerId: row.id,
                              },
                            }
                          );
                          postNotification("success", "Teams swapped");
                          setRefreshPairings(true);
                          setLoading(false);
                          setOpen(false);
                          return;
                        } catch (err) {
                          postNotification("error", err);
                        }
                        setLoading(false);
                      }}
                      sx={{
                        p: 1,
                        mb: 1,
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: 1,
                        boxShadow: 1,
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      <Grid item xs={12}>
                        {row.name}
                      </Grid>
                    </Grid>
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export function CreatePairingModal(props) {
  const {
    organize,
    round,
    event,
    player,
    open,
    setOpen,
    players,
    setRefreshPairings,
    setLoading,
  } = props;

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Create Pairing
            </Typography>
          </Grid>
        </Grid>

        {event?.boardGameEvent ? (
          <SeatedPairingFormik
            organize={organize}
            player={player}
            players={players}
            event={event}
            round={round}
            setLoading={setLoading}
            setRefreshPairings={setRefreshPairings}
            setOpen={setOpen}
          />
        ) : (
          <PairingFormik
            organize={organize}
            player={player}
            players={players}
            event={event}
            round={round}
            setLoading={setLoading}
            setRefreshPairings={setRefreshPairings}
            setOpen={setOpen}
          />
        )}
      </Box>
    </Modal>
  );
}

function SeatedPairingFormik({
  organize,
  player,
  players,
  event,
  round,
  setLoading,
  setRefreshPairings,
  setOpen,
}) {
  return (
    <Formik
      initialValues={{
        seatedPlayers: [
          {
            playerId: player?.id || "",
          },
          { playerId: "" },
        ],
        table: 0,
      }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        seatedPlayers: Yup.array()
          .of(
            Yup.object().shape({
              playerId: Yup.string().nullable().required("Required"),
            })
          )
          .min(2, "Must have at least 2 Players"),
      })}
      onSubmit={async (values) => {
        let body = {
          eventId: event.id,
          seatedPlayers: values.seatedPlayers,
          table: values.table,
          pairingType: "SeatedPairing",
          round: round !== undefined ? round : event.currentRound,
        };
        setLoading(true);
        try {
          let pairing = await postData("/pairings", {
            body: body,
          });
          postNotification("success", "Pairing Created");
          if (organize) {
            setRefreshPairings(true);
            setLoading(false);
            setOpen(false);
          } else {
            window.location.assign(`/game/seatedpairing/${pairing.id}`);
          }
          return;
        } catch (err) {
          postNotification("error", err);
        }
        setLoading(false);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="table"
                label="Table"
                value={values.table}
                variant="outlined"
                fullWidth
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.table && errors.table)}
                helperText={touched.table && errors.table}
                type="number"
                inputProps={{
                  min: 0,
                }}
              />
            </Grid>

            <FieldArray
              name="seatedPlayers"
              render={(arrayHelpers) => (
                <>
                  {values.seatedPlayers?.length > 0 &&
                    values.seatedPlayers.map((seatedPlayer, index) => (
                      <Grid key={index} item xs={12}>
                        <GenericPicker
                          name={`seatedPlayers[${index}].playerId`}
                          label={`Seat ${index + 1}`}
                          value={values.seatedPlayers?.[index]?.playerId}
                          handleChange={handleChange}
                          list={
                            players?.map((player) => {
                              return {
                                value: player.id,
                                label: player.name,
                              };
                            }) || []
                          }
                          inclAny={false}
                          error={Boolean(
                            touched.seatedPlayers?.[index]?.playerId &&
                              errors.seatedPlayers?.[index]?.playerId
                          )}
                          helperText={
                            touched.seatedPlayers?.[index]?.playerId &&
                            errors.seatedPlayers?.[index]?.playerId
                          }
                          disabled={index === 0 && player}
                          required
                          endAdornment={
                            index > 0 ? (
                              <InputAdornment position="end">
                                <Button
                                  sx={{ minWidth: "40px" }}
                                  onClick={() => {
                                    arrayHelpers.remove(index);
                                  }}
                                  disabled={values.seatedPlayers.length <= 2}
                                >
                                  <BCPXmark />
                                </Button>
                              </InputAdornment>
                            ) : null
                          }
                        />
                      </Grid>
                    ))}
                  <Grid item xs={12}>
                    <Button
                      type="button"
                      color="inherit"
                      variant="outlined"
                      fullWidth
                      startIcon={<BCPSquarePlus />}
                      onClick={() => {
                        arrayHelpers.push({ playerId: "" });
                      }}
                    >
                      Add Player
                    </Button>
                  </Grid>
                </>
              )}
            />

            {Boolean(touched.seatedPlayers && errors.seatedPlayers) && (
              <FormHelperText error>{errors.seatedPlayers}</FormHelperText>
            )}

            <Grid item xs={12}>
              <Button
                fullWidth
                color="success"
                variant="contained"
                type="submit"
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}

function PairingFormik({
  organize,
  player,
  players,
  event,
  round,
  setLoading,
  setRefreshPairings,
  setOpen,
}) {
  return (
    <Formik
      initialValues={{
        player1Id: player?.userId || "",
        player2Id: "",
        table: 0,
      }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        player1Id: Yup.string().required("Required"),
        player2Id: Yup.string().required("Required"),
      })}
      onSubmit={async (values) => {
        let body = {
          eventId: event.id,
          player1: { userId: values.player1Id },
          player2: { userId: values.player2Id },
          table: values.table,
          pairingType: event?.boardGameEvent ? "SeatedPairing" : "Pairing",
          round: round !== undefined ? round : event.currentRound,
        };

        setLoading(true);
        try {
          let pairing = await postData("/pairings", {
            body: body,
          });

          postNotification("success", "Pairing Created");

          if (organize) {
            setRefreshPairings(true);
            setLoading(false);
            setOpen(false);
          } else {
            window.location.assign(
              `/game/${
                pairing?.pairingType
                  ? pairing.pairingType.toLowerCase()
                  : "pairing"
              }/${pairing.id}`
            );
          }

          return;
        } catch (err) {
          postNotification("error", err);
        }
        setLoading(false);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="table"
                label="Table"
                value={values.table}
                variant="outlined"
                fullWidth
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.table && errors.table)}
                helperText={touched.table && errors.table}
                type="number"
                inputProps={{
                  min: 0,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <GenericPicker
                name="player1Id"
                label="Player 1"
                value={values.player1Id}
                handleChange={handleChange}
                list={
                  players?.map((player) => {
                    return { value: player.userId, label: player.name };
                  }) || []
                }
                inclAny={false}
                error={Boolean(touched.player1Id && errors.player1Id)}
                helperText={touched.player1Id && errors.player1Id}
                disabled={player}
              />
            </Grid>

            <Grid item xs={12}>
              <GenericPicker
                name="player2Id"
                label="Player 2"
                value={values.player2Id}
                handleChange={handleChange}
                list={
                  players?.map((player) => {
                    return { value: player.userId, label: player.name };
                  }) || []
                }
                inclAny={false}
                error={Boolean(touched.player2Id && errors.player2Id)}
                helperText={touched.player2Id && errors.player2Id}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                fullWidth
                color="success"
                variant="contained"
                type="submit"
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}

export function PairingModal(props) {
  const {
    pairing,
    setPairing,
    setRefreshPairings,
    event,
    setSwapTableModal,
    setOptionsAnchorEl4,
  } = props;
  const open = Boolean(pairing);

  const [pairingOpen, setPairingOpen] = useState(false);

  if (!open) return <></>;
  return (
    <Modal
      disableAutoFocus
      open={Boolean(pairing)}
      onClose={() => {
        setPairing(null);
        setPairingOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      {pairing && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "90vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: [1, 2],
            pt: 4,
            mt: [0, 2],
            mb: [0, 2],
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{
              position: "absolute",
              top: "4px",
              right: "4px",
            }}
            onClick={() => {
              setPairing(null);
              setPairingOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid container spacing={1} sx={{ pt: 2, mt: pairingOpen ? -1 : 1 }}>
            {pairingOpen ? (
              <Grid item xs={12}>
                <GameRouter
                  pType={pairing?.pairingType}
                  objId={pairing?.id}
                  modal
                  setP={setPairing}
                  setRefreshPairings={setRefreshPairings}
                  event={event}
                  setSwapTableModal={setSwapTableModal}
                  setModalOpen={setPairingOpen}
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      setPairingOpen(true);
                    }}
                  >
                    Open Scorecard
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    endIcon={<BCPAngleDown />}
                    onClick={(e) => {
                      setOptionsAnchorEl4(e.currentTarget);
                    }}
                  >
                    Options
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      )}
    </Modal>
  );
}

export function RoundTimerModal(props) {
  const { event, setEvent, onSave } = props;
  const earliestDate = moment();
  const open = Boolean(event);
  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={Boolean(event)}
      onClose={() => {
        setEvent(null);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {event ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "2px solid #fff",
            borderRadius: 1,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setEvent(null);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" component="h2">
                Timer Options
              </Typography>
            </Grid>
          </Grid>

          <Formik
            initialValues={{
              timerData: {
                hrs: event?.defaultRoundLength
                  ? Math.floor(event.defaultRoundLength / 60 / 60)
                  : 2,
                mins: event?.defaultRoundLength
                  ? Math.floor(event.defaultRoundLength / 60) % 60
                  : 30,
              },
            }}
            enableReinitialize
            validationSchema={Yup.object().shape({
              timerData: Yup.object().shape({
                hrs: Yup.string().max(255).required("Required"),
                mins: Yup.string().max(255).required("Required"),
              }),
            })}
            onSubmit={async (values) => {
              await onSave(values);
              return;
            }}
          >
            {({ errors, handleSubmit, touched, values, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TimerPicker
                      label="Set Length"
                      required
                      name="timerData"
                      value={values.timerData}
                      setFieldValue={setFieldValue}
                      touched={touched.timerData}
                      error={errors.timerData}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                    >
                      Start Timer Now
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>

          <Divider sx={{ mt: 2, mb: 2 }} />

          <Formik
            initialValues={{
              startTime: earliestDate.format("YYYY-MM-DDTHH:mm"),
              endTime: earliestDate
                .add(event?.defaultRoundLength || 9000, "seconds")
                .format("YYYY-MM-DDTHH:mm"),
            }}
            enableReinitialize
            validationSchema={Yup.object().shape({
              startTime: Yup.string()
                .required("Required")
                .test("Is valid time?", "Invalid start time", (value) => {
                  if (!value || value.trim() === "") {
                    return false;
                  }
                  return moment(value, "YYYY-MM-DDTHH:mm", true).isValid();
                }),
              endTime: Yup.string()
                .required("Required")
                .test("Is valid time?", "Invalid end time", (value) => {
                  if (!value || value.trim() === "") {
                    return false;
                  }
                  return moment(value, "YYYY-MM-DDTHH:mm", true).isValid();
                }),
            })}
            onSubmit={async (values) => {
              try {
                if (moment(values.startTime).isAfter(moment(values.endTime))) {
                  let error = new Error(
                    "Start Time must be before the End Time"
                  );
                  error.name = "Validation Error";
                  throw error;
                }
                await onSave(values);
              } catch (err) {
                postNotification(
                  "error",
                  err.name === "Validation Error" ? err.message : err
                );
              }
              return;
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <DateTimePickerComponent
                      name="startTime"
                      label="Start Time"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={Boolean(touched.startTime && errors.startTime)}
                      helperText={touched.startTime && errors.startTime}
                      value={values.startTime}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DateTimePickerComponent
                      name="endTime"
                      label="End Time"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={Boolean(touched.endTime && errors.endTime)}
                      helperText={touched.endTime && errors.endTime}
                      value={values.endTime}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                    >
                      Schedule Timer
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        <></>
      )}
    </Modal>
  );
}

export function EndEventModal(props) {
  const {
    open,
    setOpen,
    setTopCutOptions,
    event,
    setEvent,
    handleTabChange,
    setLoading,
    authContext,
    setRoundUpdating,
  } = props;

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      {event ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs>
              <Typography variant="h4" component="h2"></Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={!event?.topCut ? 6 : 12}>
              <Button
                fullWidth
                variant="outlined"
                color="success"
                onClick={async () => {
                  setOpen(false);

                  if (
                    !event?.userRole?.permissions?.circuitSubmission &&
                    authContext?.authState?.identity?.isAdmin !== true &&
                    !authContext?.authState?.identity?.adminGameSystems?.includes(
                      event?.gameSystemId
                    )
                  ) {
                    postNotification(
                      "error",
                      "Your event user role does not have access to end a tournament"
                    );
                    return;
                  }

                  setLoading(true);
                  if (setRoundUpdating) setRoundUpdating(true);
                  try {
                    let updatedEvent = await postData(`/events/${event.id}`, {
                      body: {
                        set: {
                          ended: true,
                        },
                      },
                    });
                    setEvent({ ...event, ...updatedEvent });
                    handleTabChange(null, tabIndexes.placings, updatedEvent);
                  } catch (err) {
                    postNotification("error", err);
                  }
                  setLoading(false);
                }}
              >
                End Tournament
              </Button>
            </Grid>
            {!event?.topCut &&
              !event?.singleElimination &&
              !event?.doubleElimination && (
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="success"
                    onClick={() => {
                      setTopCutOptions(event);
                      setOpen(false);
                    }}
                  >
                    Make Top Cut
                  </Button>
                </Grid>
              )}
          </Grid>
        </Box>
      ) : (
        <></>
      )}
    </Modal>
  );
}

export function ProgressModal(props) {
  const { open, value } = props;

  if (!open) return <></>;

  return (
    <Modal
      disableAutoFocus
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          maxHeight: "95vh",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress variant="determinate" value={value} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(
              value
            )}%`}</Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
